var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToolTipIcon = function SvgToolTipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.333C4.326 1.333 1.333 4.326 1.333 8S4.326 14.667 8 14.667 14.667 11.674 14.667 8 11.674 1.333 8 1.333Zm0 1.334A5.323 5.323 0 0 1 13.333 8 5.323 5.323 0 0 1 8 13.333 5.323 5.323 0 0 1 2.667 8 5.323 5.323 0 0 1 8 2.667Zm-.667 2V6h1.334V4.667H7.333Zm0 2.666v4h1.334v-4H7.333Z",
    fill: "#4E6DF5"
  })));
};
export default SvgToolTipIcon;